import {MODAL_TYPE, showModal} from '../../../../forecast-app/shared/components/modals/generic_modal_conductor';
import {NovaSaveAsVersionModalProps} from './NovaSaveAsVersionModal';

export type NovaSaveAsVersionModalPayload = Omit<NovaSaveAsVersionModalProps, 'onClose'>;

export const showNovaSaveAsVersionModal = (props: NovaSaveAsVersionModalPayload): void => {
	showModal({type: MODAL_TYPE.NOVA_SAVE_AS_VERSION, ...props});
};
